/**
 * @desc 获取城市信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseCityResponseDto>>;
export function request(body: defs.basics.StateCheckRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/city/getCityList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
